<div class="flex flex-col w-full relative">
    <!-- Label with optional required asterisk -->
    <label *ngIf="label()"
        class="flex items-center gap-1 text-[10px] font-black text-text-muted uppercase tracking-[0.2em] ml-1 mb-1">
        {{ label() }}
        <span *ngIf="required()" class="text-red-500 font-black text-lg">*</span>
    </label>

    <div class="relative flex items-stretch group">
        <button type="button" (click)="openSearch()" [ngClass]="[sizeClasses(), classList()]"
            [class.!border-red-400]="error()" [class.pl-10]="icon()"
            class="w-full text-left bg-white dark:bg-slate-800/40 border border-foreground/10 dark:border-white/5 rounded-xl transition-all duration-200 outline-none
             hover:border-primary/40 focus:border-primary focus:ring-2 focus:ring-primary/10 flex items-center justify-between group/btn overflow-hidden"
             [class.!rounded-r-none]="type() === 'patient'">

            <!-- Icon -->
            <div *ngIf="icon()"
                class="absolute left-3.5 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-primary transition-colors z-10 pointer-events-none flex items-center">
                <iconify-icon [attr.icon]="icon()" [attr.width]="iconSize()" [attr.height]="iconSize()"></iconify-icon>
            </div>

            <!-- Value / Placeholder -->
            <span class="truncate flex-1" [class.text-text-muted]="!displayValue()" [class.text-foreground]="displayValue()">
                {{ displayValue() || placeholder() }}
            </span>

            <!-- Search / Clear Icon (Right) -->
            <div class="ml-2 flex items-center z-20">
                <!-- Magnifier if Empty -->
                <iconify-icon *ngIf="!displayValue()" icon="solar:magnifer-bold-duotone" [attr.width]="iconSize()"
                    [attr.height]="iconSize()"
                    class="text-text-muted group-hover/btn:text-primary transition-colors opacity-40 group-hover/btn:opacity-100 flex items-center"></iconify-icon>

                <!-- Trash/Clear if has Value -->
                <button type="button" *ngIf="displayValue()" (click)="$event.stopPropagation(); clearValue()"
                    class="text-text-muted hover:text-red-500 transition-colors flex items-center active:scale-95">
                    <iconify-icon icon="solar:trash-bin-trash-bold-duotone" [attr.width]="iconSize()"
                        [attr.height]="iconSize()"></iconify-icon>
                </button>
            </div>
        </button>
        <button type="button" *ngIf="type() === 'patient'" (click)="$event.stopPropagation(); openQuickPatient()"
            [ngClass]="sizeClasses()"
            class="bg-primary hover:bg-primary-hover text-white flex items-center justify-center transition-colors shadow-sm active:scale-95 !rounded-r-xl !rounded-l-none border-l border-white/20 shrink-0 px-3">
            <span class="iconify" data-icon="mdi:user-plus" data-width="18" data-height="18"></span>
        </button>

    </div>

    <!-- Help/Error text -->
    <span *ngIf="error()"
        class="mt-1.5 ml-1 text-[9px] font-black text-red-500 uppercase tracking-tighter animate-fade-in flex items-center gap-1.5">
        <iconify-icon icon="solar:danger-bold-duotone" width="12" height="12"></iconify-icon>
        {{ error() }}
    </span>
</div>
